import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { hasUserCookie } from "@/lib/auth-cookie";
import { queryKeys } from "@/lib/query-keys";
import { fetchUserProfile } from "@/lib/user-profile";

export function useUser() {
	return useQuery({
		queryKey: queryKeys.user.profile(),
		queryFn: ({ signal }) => fetchUserProfile(signal),
		enabled: hasUserCookie(),
		staleTime: 0,
		gcTime: 1000 * 60 * 60,
		retry: false,
	});
}

export function useUserCoins() {
	return useQuery({
		queryKey: queryKeys.user.coins(),
		queryFn: async ({ signal }) => {
			const response = await api.get<{ coins: number }>("/api/v3/user/profile/coins", signal);
			return response.coins;
		},
		enabled: hasUserCookie(),
		staleTime: 1000 * 60 * 2,
	});
}
